import { render, staticRenderFns } from "./creatBidFile.vue?vue&type=template&id=42404a70&scoped=true"
import script from "./creatBidFile.vue?vue&type=script&lang=js"
export * from "./creatBidFile.vue?vue&type=script&lang=js"
import style0 from "./creatBidFile.vue?vue&type=style&index=0&id=42404a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42404a70",
  null
  
)

export default component.exports